import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'GridLink',
    props: {
        text: null
    },
    emits: ["click"],
    setup(__props, { emit }) {
        return { __sfc: true, emit };
    }
});
